import './IconContent.css';

export const IconContent = ({ 
  icon,
  children,
  className = '' 
}) => {
  return (
    <div className={`icon-content ${className}`.trim()}>
      <div className="icon-content__icon">
        {icon}
      </div>
      <div className="icon-content__content">
        {children}
      </div>
    </div>
  );
};

